const DICT = {
  'common.loading': 'Chargement…',
  'common.save': 'Enregistrer',
  'common.cancel': 'Annuler',
  'common.delete': 'Supprimer',
  'common.add_item': 'Ajouter un cadeau',
  'auth.sign_in.heading': 'Se connecter',
  'auth.sign_in.email_placeholder': 'votre@email.fr',
  'auth.sign_in.send_link': 'Recevoir un lien de connexion',
  'auth.sign_in.or_google': 'Ou continuer avec Google',
  'landing.title': 'Liste de Naissance',
  'landing.tagline': 'Créez votre liste, partagez avec vos proches.',
  'landing.cta': 'Créer ma liste',
  'owner.registry.see_list': 'Voir la liste',
} as const

export type DictKey = keyof typeof DICT

export function t(key: DictKey): string {
  return DICT[key]
}
